import type { Product } from "../types";
import chanelNo5Image from "../images/products/chanelNo5.jpg";
import diorJadoreImage from "../images/products/diorJadore.jpg";
import tomFordBlackOrchidImage from "../images/products/tomFordBlackOrchid.jpg";
import yslBlackOpiumImage from "../images/products/yslBlackOpium.jpg";
import bleuDeChanelImage from "../images/products/bleuDeChanel.jpg";
import diorSauvageImage from "../images/products/diorSauvage.jpg";
import acquaDiGioImage from "../images/products/acquaDiGio.jpg";
import lightBlueImage from "../images/products/lightBlue.jpg";
import laVieEstBelleImage from "../images/products/laVieEstBelle.jpg";
import angelImage from "../images/products/angel.jpg";
import ckOneImage from "../images/products/ckOne.jpg";
import acquaDiParmaImage from "../images/products/acquaDiParma.jpg";
import missDiorImage from "../images/products/missDior.jpg";
import flowerbombImage from "../images/products/flowerbomb.jpg";
import shalimarImage from "../images/products/shalimar.jpg";
import oudWoodImage from "../images/products/oudWood.jpg";
import terreDHermesImage from "../images/products/terreDHermes.jpg";
import bvlgariManImage from "../images/products/bvlgariMan.jpg";
import lightBlueIntenseImage from "../images/products/lightBlueIntense.jpg";
import acquaDiGioProfumoImage from "../images/products/acquaDiGioProfumo.jpg";
import laNuitTresorImage from "../images/products/laNuitTresor.jpg";
import angelMuseImage from "../images/products/angelMuse.jpg";
import ckOneSummerImage from "../images/products/ckOneSummer.jpg";
import acquaDiParmaBluImage from "../images/products/acquaDiParmaBlu.jpg";
import chanelGabrielleImage from "../images/products/chanelGabrielle.jpg";
import diorHommeImage from "../images/products/diorHomme.jpg";
import bvlgariAqvaImage from "../images/products/bvlgariAqva.jpg";
import gucciBloomImage from "../images/products/gucciBloom.jpg";
import yslYImage from "../images/products/yslY.jpg";
import pradaLunaRossaImage from "../images/products/pradaLunaRossa.jpg";

export const products: Product[] = [
  // Floral Perfumes
  {
    id: 1,
    name: "Chanel N°5",
    description: "The iconic floral fragrance with notes of rose and jasmine",
    price: 38500,
    originalPrice: 42000,
    image: chanelNo5Image,
    category: "floral",
    rating: 4.8,
    discount: 9,
    stock: 15,
    quantity: 1,
    sold: 8,
    features: [
      "Top notes: Aldehydes, Neroli",
      "Heart notes: Rose, Jasmine",
      "Base notes: Vanilla, Musk",
      "Long-lasting fragrance",
      "Iconic Chanel bottle"
    ],
    specifications: {
      brand: "Chanel",
      model: "N°5",
      volume: "100ml",
      type: "Eau de Parfum",
      concentration: "15-20%",
      gender: "Women"
    }
  },
  {
    id: 2,
    name: "Dior J'adore",
    description: "A luxurious floral fragrance with notes of rose and ylang-ylang",
    price: 35000,
    originalPrice: 38000,
    image: diorJadoreImage,
    category: "floral",
    rating: 4.7,
    discount: 8,
    stock: 12,
    quantity: 1,
    sold: 6,
    features: [
      "Top notes: Ylang-Ylang, Rose",
      "Heart notes: Jasmine, Lily",
      "Base notes: Vanilla, Musk",
      "Elegant scent",
      "Premium Dior packaging"
    ],
    specifications: {
      brand: "Dior",
      model: "J'adore",
      volume: "100ml",
      type: "Eau de Parfum",
      concentration: "15-20%",
      gender: "Women"
    }
  },

  // Oriental Perfumes
  {
    id: 3,
    name: "Tom Ford Black Orchid",
    description: "A rich oriental fragrance with black truffle and black orchid",
    price: 40000,
    originalPrice: 44000,
    image: tomFordBlackOrchidImage,
    category: "oriental",
    rating: 4.6,
    discount: 9,
    stock: 8,
    quantity: 1,
    sold: 4,
    features: [
      "Top notes: Black Truffle, Ylang-Ylang",
      "Heart notes: Black Orchid, Spices",
      "Base notes: Vanilla, Patchouli",
      "Luxurious scent",
      "Signature Tom Ford bottle"
    ],
    specifications: {
      brand: "Tom Ford",
      model: "Black Orchid",
      volume: "100ml",
      type: "Eau de Parfum",
      concentration: "20-25%",
      gender: "Unisex"
    }
  },
  {
    id: 4,
    name: "Yves Saint Laurent Black Opium",
    description: "An addictive oriental fragrance with coffee and vanilla",
    price: 32000,
    originalPrice: 35000,
    image: yslBlackOpiumImage,
    category: "oriental",
    rating: 4.5,
    discount: 10,
    stock: 10,
    quantity: 1,
    sold: 5,
    features: [
      "Top notes: Coffee, Pink Pepper",
      "Heart notes: Orange Blossom, Jasmine",
      "Base notes: Vanilla, Patchouli",
      "Addictive scent",
      "Luxury YSL packaging"
    ],
    specifications: {
      brand: "Yves Saint Laurent",
      model: "Black Opium",
      volume: "100ml",
      type: "Eau de Parfum",
      concentration: "20-25%",
      gender: "Women"
    }
  },

  // Woody Perfumes
  {
    id: 5,
    name: "Bleu de Chanel",
    description: "A sophisticated woody fragrance with notes of cedar and sandalwood",
    price: 36000,
    originalPrice: 39000,
    image: bleuDeChanelImage,
    category: "woody",
    rating: 4.7,
    discount: 9,
    stock: 20,
    quantity: 1,
    sold: 12,
    features: [
      "Top notes: Grapefruit, Mint",
      "Heart notes: Cedar, Sandalwood",
      "Base notes: Amber, Vanilla",
      "Masculine scent",
      "Premium Chanel bottle"
    ],
    specifications: {
      brand: "Chanel",
      model: "Bleu de Chanel",
      volume: "100ml",
      type: "Eau de Parfum",
      concentration: "15-20%",
      gender: "Men"
    }
  },
  {
    id: 6,
    name: "Dior Sauvage",
    description: "A fresh woody fragrance with bergamot and ambroxan",
    price: 34000,
    originalPrice: 37000,
    image: diorSauvageImage,
    category: "woody",
    rating: 4.8,
    discount: 8,
    stock: 15,
    quantity: 1,
    sold: 8,
    features: [
      "Top notes: Bergamot, Pepper",
      "Heart notes: Lavender, Pink Pepper",
      "Base notes: Ambroxan, Cedar",
      "Fresh scent",
      "Elegant Dior design"
    ],
    specifications: {
      brand: "Dior",
      model: "Sauvage",
      volume: "100ml",
      type: "Eau de Parfum",
      concentration: "15-20%",
      gender: "Men"
    }
  },

  // Fresh Perfumes
  {
    id: 7,
    name: "Acqua di Gio",
    description: "A fresh aquatic fragrance with marine notes",
    price: 28000,
    originalPrice: 31000,
    image: acquaDiGioImage,
    category: "fresh",
    rating: 4.6,
    discount: 11,
    stock: 25,
    quantity: 1,
    sold: 15,
    features: [
      "Top notes: Bergamot, Neroli",
      "Heart notes: Jasmine, Marine Notes",
      "Base notes: Musk, Cedar",
      "Light scent",
      "Classic Armani bottle"
    ],
    specifications: {
      brand: "Giorgio Armani",
      model: "Acqua di Gio",
      volume: "100ml",
      type: "Eau de Toilette",
      concentration: "10-15%",
      gender: "Men"
    }
  },
  {
    id: 8,
    name: "Light Blue",
    description: "A fresh citrus-based fragrance with apple and bamboo",
    price: 25000,
    originalPrice: 28000,
    image: lightBlueImage,
    category: "fresh",
    rating: 4.5,
    discount: 13,
    stock: 10,
    quantity: 1,
    sold: 5,
    features: [
      "Top notes: Apple, Bamboo",
      "Heart notes: Jasmine, White Rose",
      "Base notes: Cedar, Musk",
      "Fresh scent",
      "Dolce & Gabbana design"
    ],
    specifications: {
      brand: "Dolce & Gabbana",
      model: "Light Blue",
      volume: "100ml",
      type: "Eau de Toilette",
      concentration: "10-15%",
      gender: "Women"
    }
  },

  // Gourmand Perfumes
  {
    id: 9,
    name: "La Vie Est Belle",
    description: "A sweet gourmand fragrance with iris and vanilla",
    price: 32000,
    originalPrice: 35000,
    image: laVieEstBelleImage,
    category: "gourmand",
    rating: 4.6,
    discount: 10,
    stock: 8,
    quantity: 1,
    sold: 4,
    features: [
      "Top notes: Blackcurrant, Pear",
      "Heart notes: Iris, Jasmine",
      "Base notes: Vanilla, Tonka Bean",
      "Sweet scent",
      "Luxury Lancôme bottle"
    ],
    specifications: {
      brand: "Lancôme",
      model: "La Vie Est Belle",
      volume: "100ml",
      type: "Eau de Parfum",
      concentration: "15-20%",
      gender: "Women"
    }
  },
  {
    id: 10,
    name: "Angel",
    description: "A unique gourmand fragrance with chocolate and patchouli",
    price: 34000,
    originalPrice: 37000,
    image: angelImage,
    category: "gourmand",
    rating: 4.4,
    discount: 10,
    stock: 15,
    quantity: 1,
    sold: 8,
    features: [
      "Top notes: Bergamot, Red Berries",
      "Heart notes: Chocolate, Honey",
      "Base notes: Patchouli, Vanilla",
      "Unique scent",
      "Iconic Mugler bottle"
    ],
    specifications: {
      brand: "Mugler",
      model: "Angel",
      volume: "100ml",
      type: "Eau de Parfum",
      concentration: "20-25%",
      gender: "Women"
    }
  },

  // Aromatic Perfumes
  {
    id: 11,
    name: "CK One",
    description: "A fresh aromatic fragrance with green tea and bergamot",
    price: 15000,
    originalPrice: 18000,
    image: ckOneImage,
    category: "aromatic",
    rating: 4.5,
    discount: 14,
    stock: 15,
    quantity: 1,
    sold: 8,
    features: [
      "Top notes: Bergamot, Green Tea",
      "Heart notes: Jasmine, Freesia",
      "Base notes: Musk, Cedar",
      "Fresh scent",
      "Minimalist design"
    ],
    specifications: {
      brand: "Calvin Klein",
      model: "CK One",
      volume: "100ml",
      type: "Eau de Toilette",
      concentration: "10-15%",
      gender: "Unisex"
    }
  },
  {
    id: 12,
    name: "Acqua di Parma",
    description: "A classic aromatic fragrance with citrus and herbs",
    price: 36000,
    originalPrice: 39000,
    image: acquaDiParmaImage,
    category: "aromatic",
    rating: 4.7,
    discount: 9,
    stock: 25,
    quantity: 1,
    sold: 12,
    features: [
      "Top notes: Lemon, Bergamot",
      "Heart notes: Lavender, Rosemary",
      "Base notes: Cedar, Musk",
      "Classic scent",
      "Luxury Italian design"
    ],
    specifications: {
      brand: "Acqua di Parma",
      model: "Colonia",
      volume: "100ml",
      type: "Eau de Cologne",
      concentration: "10-15%",
      gender: "Unisex"
    }
  },

  // Additional Floral Perfumes
  {
    id: 13,
    name: "Miss Dior",
    description: "A romantic floral fragrance with rose and peony",
    price: 33000,
    originalPrice: 36000,
    image: missDiorImage,
    category: "floral",
    rating: 4.6,
    discount: 10,
    stock: 18,
    quantity: 1,
    sold: 10,
    features: [
      "Top notes: Bergamot, Mandarin",
      "Heart notes: Rose, Peony",
      "Base notes: Patchouli, Musk",
      "Romantic scent",
      "Elegant Dior bottle"
    ],
    specifications: {
      brand: "Dior",
      model: "Miss Dior",
      volume: "100ml",
      type: "Eau de Parfum",
      concentration: "15-20%",
      gender: "Women"
    }
  },
  {
    id: 14,
    name: "Flowerbomb",
    description: "A luxurious floral fragrance with rose and orchid",
    price: 34000,
    originalPrice: 37000,
    image: flowerbombImage,
    category: "floral",
    rating: 4.7,
    discount: 10,
    stock: 15,
    quantity: 1,
    sold: 7,
    features: [
      "Top notes: Tea, Bergamot",
      "Heart notes: Rose, Orchid",
      "Base notes: Vanilla, Musk",
      "Luxurious scent",
      "Viktor & Rolf design"
    ],
    specifications: {
      brand: "Viktor & Rolf",
      model: "Flowerbomb",
      volume: "100ml",
      type: "Eau de Parfum",
      concentration: "20-25%",
      gender: "Women"
    }
  },

  // Additional Oriental Perfumes
  {
    id: 15,
    name: "Shalimar",
    description: "A classic oriental fragrance with vanilla and iris",
    price: 36000,
    originalPrice: 39000,
    image: shalimarImage,
    category: "oriental",
    rating: 4.8,
    discount: 9,
    stock: 12,
    quantity: 1,
    sold: 6,
    features: [
      "Top notes: Bergamot, Lemon",
      "Heart notes: Iris, Rose",
      "Base notes: Vanilla, Tonka Bean",
      "Classic scent",
      "Historic Guerlain bottle"
    ],
    specifications: {
      brand: "Guerlain",
      model: "Shalimar",
      volume: "100ml",
      type: "Eau de Parfum",
      concentration: "20-25%",
      gender: "Women"
    }
  },
  {
    id: 16,
    name: "Oud Wood",
    description: "A luxurious oriental fragrance with oud and spices",
    price: 40000,
    originalPrice: 44000,
    image: oudWoodImage,
    category: "oriental",
    rating: 4.6,
    discount: 9,
    stock: 10,
    quantity: 1,
    sold: 5,
    features: [
      "Top notes: Cardamom, Coriander",
      "Heart notes: Oud, Sandalwood",
      "Base notes: Vanilla, Amber",
      "Luxurious scent",
      "Tom Ford design"
    ],
    specifications: {
      brand: "Tom Ford",
      model: "Oud Wood",
      volume: "100ml",
      type: "Eau de Parfum",
      concentration: "20-25%",
      gender: "Unisex"
    }
  },

  // Additional Woody Perfumes
  {
    id: 17,
    name: "Terre d'Hermès",
    description: "A sophisticated woody fragrance with grapefruit and cedar",
    price: 35000,
    originalPrice: 38000,
    image: terreDHermesImage,
    category: "woody",
    rating: 4.7,
    discount: 10,
    stock: 20,
    quantity: 1,
    sold: 10,
    features: [
      "Top notes: Grapefruit, Orange",
      "Heart notes: Cedar, Pepper",
      "Base notes: Vetiver, Benzoin",
      "Sophisticated scent",
      "Hermès design"
    ],
    specifications: {
      brand: "Hermès",
      model: "Terre d'Hermès",
      volume: "100ml",
      type: "Eau de Toilette",
      concentration: "15-20%",
      gender: "Men"
    }
  },
  {
    id: 18,
    name: "Bvlgari Man",
    description: "A modern woody fragrance with tea and cedar",
    price: 32000,
    originalPrice: 35000,
    image: bvlgariManImage,
    category: "woody",
    rating: 4.5,
    discount: 10,
    stock: 12,
    quantity: 1,
    sold: 6,
    features: [
      "Top notes: Tea, Bergamot",
      "Heart notes: Cedar, Cardamom",
      "Base notes: Musk, Amber",
      "Modern scent",
      "Bvlgari design"
    ],
    specifications: {
      brand: "Bvlgari",
      model: "Bvlgari Man",
      volume: "100ml",
      type: "Eau de Toilette",
      concentration: "15-20%",
      gender: "Men"
    }
  },

  // Additional Fresh Perfumes
  {
    id: 19,
    name: "Light Blue Intense",
    description: "A fresh aquatic fragrance with jasmine and musk",
    price: 28000,
    originalPrice: 31000,
    image: lightBlueIntenseImage,
    category: "fresh",
    rating: 4.6,
    discount: 11,
    stock: 8,
    quantity: 1,
    sold: 4,
    features: [
      "Top notes: Apple, Bamboo",
      "Heart notes: Jasmine, White Rose",
      "Base notes: Cedar, Musk",
      "Fresh scent",
      "Dolce & Gabbana design"
    ],
    specifications: {
      brand: "Dolce & Gabbana",
      model: "Light Blue Intense",
      volume: "100ml",
      type: "Eau de Toilette",
      concentration: "10-15%",
      gender: "Women"
    }
  },
  {
    id: 20,
    name: "Acqua di Gio Profumo",
    description: "A deep aquatic fragrance with incense and patchouli",
    price: 35000,
    originalPrice: 38000,
    image: acquaDiGioProfumoImage,
    category: "fresh",
    rating: 4.7,
    discount: 10,
    stock: 10,
    quantity: 1,
    sold: 5,
    features: [
      "Top notes: Bergamot, Neroli",
      "Heart notes: Incense, Rosemary",
      "Base notes: Patchouli, Musk",
      "Deep scent",
      "Armani design"
    ],
    specifications: {
      brand: "Giorgio Armani",
      model: "Acqua di Gio Profumo",
      volume: "100ml",
      type: "Eau de Parfum",
      concentration: "15-20%",
      gender: "Men"
    }
  },

  // Additional Gourmand Perfumes
  {
    id: 21,
    name: "La Nuit Trésor",
    description: "A sweet gourmand fragrance with rose and vanilla",
    price: 33000,
    originalPrice: 36000,
    image: laNuitTresorImage,
    category: "gourmand",
    rating: 4.5,
    discount: 10,
    stock: 15,
    quantity: 1,
    sold: 8,
    features: [
      "Top notes: Rose, Bergamot",
      "Heart notes: Vanilla, Coffee",
      "Base notes: Tonka Bean, Musk",
      "Sweet scent",
      "Lancôme design"
    ],
    specifications: {
      brand: "Lancôme",
      model: "La Nuit Trésor",
      volume: "100ml",
      type: "Eau de Parfum",
      concentration: "15-20%",
      gender: "Women"
    }
  },
  {
    id: 22,
    name: "Angel Muse",
    description: "A modern gourmand fragrance with hazelnut and vanilla",
    price: 32000,
    originalPrice: 35000,
    image: angelMuseImage,
    category: "gourmand",
    rating: 4.4,
    discount: 10,
    stock: 20,
    quantity: 1,
    sold: 10,
    features: [
      "Top notes: Pink Pepper, Bergamot",
      "Heart notes: Hazelnut, Vanilla",
      "Base notes: Patchouli, Musk",
      "Modern scent",
      "Mugler design"
    ],
    specifications: {
      brand: "Mugler",
      model: "Angel Muse",
      volume: "100ml",
      type: "Eau de Parfum",
      concentration: "15-20%",
      gender: "Women"
    }
  },

  // Additional Aromatic Perfumes
  {
    id: 23,
    name: "CK One Summer",
    description: "A fresh aromatic fragrance with lime and coconut",
    price: 12000,
    originalPrice: 15000,
    image: ckOneSummerImage,
    category: "aromatic",
    rating: 4.3,
    discount: 17,
    stock: 12,
    quantity: 1,
    sold: 6,
    features: [
      "Top notes: Lime, Coconut",
      "Heart notes: Ginger, Mint",
      "Base notes: Musk, Cedar",
      "Summer scent",
      "Calvin Klein design"
    ],
    specifications: {
      brand: "Calvin Klein",
      model: "CK One Summer",
      volume: "100ml",
      type: "Eau de Toilette",
      concentration: "10-15%",
      gender: "Unisex"
    }
  },
  {
    id: 24,
    name: "Acqua di Parma Blu Mediterraneo",
    description: "A fresh aromatic fragrance with citrus and herbs",
    price: 36000,
    originalPrice: 39000,
    image: acquaDiParmaBluImage,
    category: "aromatic",
    rating: 4.6,
    discount: 9,
    stock: 20,
    quantity: 1,
    sold: 10,
    features: [
      "Top notes: Lemon, Bergamot",
      "Heart notes: Rosemary, Lavender",
      "Base notes: Cedar, Musk",
      "Mediterranean scent",
      "Italian design"
    ],
    specifications: {
      brand: "Acqua di Parma",
      model: "Blu Mediterraneo",
      volume: "100ml",
      type: "Eau de Toilette",
      concentration: "10-15%",
      gender: "Unisex"
    }
  },

  // Additional Products
  {
    id: 25,
    name: "Chanel Gabrielle",
    description: "A luxurious floral-oriental fragrance",
    price: 40000,
    originalPrice: 44000,
    image: chanelGabrielleImage,
    category: "floral",
    rating: 4.7,
    discount: 9,
    stock: 25,
    quantity: 1,
    sold: 12,
    features: [
      "Top notes: Orange, Grapefruit",
      "Heart notes: Jasmine, Ylang-Ylang",
      "Base notes: Vanilla, Musk",
      "Luxurious scent",
      "Chanel design"
    ],
    specifications: {
      brand: "Chanel",
      model: "Gabrielle",
      volume: "100ml",
      type: "Eau de Parfum",
      concentration: "15-20%",
      gender: "Women"
    }
  },
  {
    id: 26,
    name: "Dior Homme",
    description: "A sophisticated woody-oriental fragrance",
    price: 35000,
    originalPrice: 38000,
    image: diorHommeImage,
    category: "oriental",
    rating: 4.6,
    discount: 10,
    stock: 15,
    quantity: 1,
    sold: 8,
    features: [
      "Top notes: Bergamot, Lavender",
      "Heart notes: Iris, Amber",
      "Base notes: Vanilla, Leather",
      "Sophisticated scent",
      "Dior design"
    ],
    specifications: {
      brand: "Dior",
      model: "Homme",
      volume: "100ml",
      type: "Eau de Parfum",
      concentration: "15-20%",
      gender: "Men"
    }
  },
  {
    id: 27,
    name: "Bvlgari Aqva",
    description: "A fresh aquatic-woody fragrance",
    price: 28000,
    originalPrice: 31000,
    image: bvlgariAqvaImage,
    category: "fresh",
    rating: 4.5,
    discount: 11,
    stock: 30,
    quantity: 1,
    sold: 15,
    features: [
      "Top notes: Mandarin, Orange",
      "Heart notes: Sea Notes, Jasmine",
      "Base notes: Cedar, Musk",
      "Fresh scent",
      "Bvlgari design"
    ],
    specifications: {
      brand: "Bvlgari",
      model: "Aqva",
      volume: "100ml",
      type: "Eau de Toilette",
      concentration: "10-15%",
      gender: "Men"
    }
  },
  {
    id: 28,
    name: "Gucci Bloom",
    description: "A rich floral fragrance with tuberose and jasmine",
    price: 34000,
    originalPrice: 37000,
    image: gucciBloomImage,
    category: "floral",
    rating: 4.6,
    discount: 10,
    stock: 20,
    quantity: 1,
    sold: 10,
    features: [
      "Top notes: Jasmine, Tuberose",
      "Heart notes: Rose, Ylang-Ylang",
      "Base notes: Vanilla, Musk",
      "Rich scent",
      "Gucci design"
    ],
    specifications: {
      brand: "Gucci",
      model: "Bloom",
      volume: "100ml",
      type: "Eau de Parfum",
      concentration: "15-20%",
      gender: "Women"
    }
  },
  {
    id: 29,
    name: "YSL Y",
    description: "A fresh woody-aromatic fragrance",
    price: 32000,
    originalPrice: 35000,
    image: yslYImage,
    category: "aromatic",
    rating: 4.5,
    discount: 10,
    stock: 15,
    quantity: 1,
    sold: 8,
    features: [
      "Top notes: Bergamot, Ginger",
      "Heart notes: Sage, Lavender",
      "Base notes: Cedar, Musk",
      "Fresh scent",
      "YSL design"
    ],
    specifications: {
      brand: "Yves Saint Laurent",
      model: "Y",
      volume: "100ml",
      type: "Eau de Parfum",
      concentration: "15-20%",
      gender: "Men"
    }
  },
  {
    id: 30,
    name: "Prada Luna Rossa",
    description: "A fresh aromatic fragrance with lavender and mint",
    price: 33000,
    originalPrice: 36000,
    image: pradaLunaRossaImage,
    category: "aromatic",
    rating: 4.4,
    discount: 10,
    stock: 18,
    quantity: 1,
    sold: 9,
    features: [
      "Top notes: Bergamot, Mint",
      "Heart notes: Lavender, Rosemary",
      "Base notes: Cedar, Musk",
      "Fresh scent",
      "Prada design"
    ],
    specifications: {
      brand: "Prada",
      model: "Luna Rossa",
      volume: "100ml",
      type: "Eau de Toilette",
      concentration: "10-15%",
      gender: "Men"
    }
  }
];

export const getProductById = (id: string): Product | undefined => {
  const productId = parseInt(id);
  if (isNaN(productId)) return undefined;
  return products.find((product) => product.id === productId);
};